import { useEffect } from 'react'

import { useAuth0 } from '@auth0/auth0-react';
import { LoadingPage } from 'Pages/Shared/LoadingPage';

export const LogoutPage = () => {
    const { logout } = useAuth0();

    useEffect(() => {
        logout({
            returnTo: window.location.origin
        });
    }, []);

    return <LoadingPage />;
}